export enum PRODUCT_TYPE {
    DIGITAL_AD_INTELLIGENCE = 'DIGITAL_AD_INTELLIGENCE',
    BRAND_REPUTATION = 'BRAND_REPUTATION',
}
